import {Component, Input, OnInit} from '@angular/core';
import {REPORTS_CONSTANTS} from '../../../reports-constants';

@Component({
    selector: 'app-zones-packages-summary-report',
    templateUrl: './zones-packages-summary-report.component.html',
    styleUrls: ['./zones-packages-summary-report.component.css']
})
export class ZonesPackagesSummaryReportComponent {
    public zonesReport = REPORTS_CONSTANTS.SUMMARY_REPORTS.ZONES_REPORT;
    public zonesReportAPI = REPORTS_CONSTANTS.SUMMARY_REPORTS.ZONES_REPORT_API;

    constructor() {
    }
}
